import { api } from "@/shared/libs/axiosClient";
import type {
  CreateTmsTokenDto,
  TmsAccountsParams,
  TmsAccountsResponse,
  TmsChannelsResponse,
  TmsSchemaResponse,
} from "../types/tokens-types";

/**
 * TMS 채널 목록 조회
 */
export async function fetchTmsChannels(): Promise<string[]> {
  const response = await api.get<TmsChannelsResponse>("/tms-tokens/channels");
  return response.channels;
}

/**
 * TMS 계정 목록 조회
 */
export async function fetchTmsAccounts(params: TmsAccountsParams): Promise<TmsAccountsResponse> {
  return api.get<TmsAccountsResponse>("/tms-tokens/accounts", { params });
}

/**
 * 특정 채널의 스키마 조회
 */
export async function fetchTmsSchema(channel: string): Promise<TmsSchemaResponse> {
  return api.get<TmsSchemaResponse>("/tms-tokens/schema", {
    params: { channel },
  });
}

/**
 * TMS 토큰 생성
 */
export async function createTmsToken(dto: CreateTmsTokenDto): Promise<void> {
  await api.post("/tms-tokens/", dto);
}

/**
 * TMS 토큰 삭제 (여러 개)
 */
export async function deleteTmsTokens(accounts: Array<{ channel: string; appId: string; userId: string }>): Promise<void> {
  await api.delete("/tms-tokens/", {
    data: {
      accounts: accounts.map((a) => ({
        channel: a.channel,
        app_id: a.appId,
        user_id: a.userId,
      })),
    },
  });
}
